import React from 'react';
import Home from './components/pages/Home';
import Register from './components/pages/Register';
import { Analytics } from '@vercel/analytics/react';
import Login from './components/pages/Login';
import { BrowserRouter, Route, Redirect  } from 'react-router-dom';

const App = () => {
  const isAuthenticated = !!localStorage.getItem('session_id');
  
  return (
    <>
    
    <BrowserRouter basename="/demo/infindwebapp">
      <Route exact path="/">
        {isAuthenticated ? <Home /> : <Home />}
      </Route>
      {!isAuthenticated ? (
        <>
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
        </>
      ) : (
        <Redirect to="/" />
      )}
    </BrowserRouter>
    <Analytics />
    </>
  );
};
export default App;